import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "15",
  height: "15",
  x: ".5",
  y: ".5",
  fill: "#6C40E5",
  stroke: "#6C40E5",
  rx: "3.5"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  stroke: "#fff",
  d: "m13.323 4.76-.013-.014-.013-.014a.75.75 0 0 0-1.082-.003L7.163 9.804 4.8 7.424a.75.75 0 0 0-1.082.003c-.29.3-.29.774 0 1.074l.005.005 2.644 2.662a1.1 1.1 0 0 0 .781.332c.296 0 .57-.115.781-.331l5.328-5.351a.773.773 0 0 0 .067-1.057Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }